<template>
  <v-card class="elevation-0" :loading="loading" :disabled="loading">
    <v-card-title>Récupérer votre mot de passe</v-card-title>
    <v-card-text v-if="initialStep">
      <v-container v-if="!thanks">
        <v-alert type="error" v-if="error">{{error}}</v-alert>
        <v-form @keyup.native.enter="recovery()">
          <v-row>
            <v-text-field
              placeholder="Email"
              hide-details="auto"
              :rules="emailRules"
              v-model="model.email"
            ></v-text-field>
          </v-row>
          <v-row class="mt-3">
            <v-spacer />
            <v-btn small color="primary" @click="recovery()" class="themed">Récupérer</v-btn>
          </v-row>
         <v-row>
            <p>
              Vous avez déjà un compte,
              <a href="#" @click="$emit('connection')">connectez-vous ici!</a>
            </p>
          </v-row>
        </v-form>
      </v-container>
      <v-container v-else>
          <v-row>
              <p>
                  Un mail vous a été envoyé
              </p>
          </v-row>
      </v-container>
    </v-card-text>
    <v-card-text v-else>
      <v-container >
        <v-alert type="error" v-if="error">{{error}}</v-alert>
        <v-form @keyup.native.enter="reset()">
          <v-row>
            <v-text-field
              placeholder="Saisir votre nouveau mot de passe"
              type="password"
              hide-details="auto"
              :rules="passwordRules"
              v-model="resetModel.password"
            ></v-text-field>
          </v-row>
          <v-row class="mt-3">
            <v-spacer />
            <v-btn small color="primary" @click="reset()" class="themed">Rédifinir mon mot de passe</v-btn>
          </v-row>
         <v-row>
            <p>
              Vous avez déjà un compte,
              <a href="#" @click="$emit('connection')">connectez-vous ici!</a>
            </p>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: function() {
    return {
      error: null,
      initialStep:true,
      thanks:false,
      emailRules: [
        value => !!value || "Champ obligatoire.",
        value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Adresse e-mail invalide.";
        }
      ],
      passwordRules: [
        value => !!value || "Champ obligatoire.",
        value =>
          (value || "").length >= 6 ||
          "Le mot de passe doit avoir au moins 6 charactères"
      ],
      model: {
        email: null,
        url:window.location.href
      },
      resetModel:{
          token:null,
          password:null
      }
    };
  },
  computed: {
    ...mapGetters("auth", ["loading"])
  },
  mounted(){
    this.resetModel.token = this.$route.query.reset_token;
    if(this.resetModel.token){
        this.initialStep=false;
    }
  },
  methods: {
    recovery: function() {
      this.error = null;
      this.$store
        .dispatch("auth/recovery", this.model)
        .then(() => this.thanks=true)
        .catch(() => {
          this.error = "Email ou Mot de passe incorect";
        });
    },
    reset: function() {
      this.error = null;
      this.$store
        .dispatch("auth/reset", this.resetModel)
        .then(() => this.$router.push({ name: "Home" }))
        .catch(() => {
          this.error = "Email ou Mot de passe incorect";
        });
    }
  }
};
</script>